import React from "react";

const ConfirmActionModal = ({
  confirmModal,
  onClose,
  onConfirm,
}) => {
  if (!confirmModal.open) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/50 z-[130] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-6 animate-in zoom-in-95 duration-200 border border-gray-100 text-center">
        <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center text-xl mx-auto mb-4">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-1">{confirmModal.title}</h3>
        <p className="text-xs text-gray-500 leading-relaxed mb-6">{confirmModal.message}</p>
        <div className="flex gap-3">
          <button
            type="button"
            disabled={confirmModal.isProcessing}
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl font-bold text-xs text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={confirmModal.isProcessing}
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl font-bold text-xs text-white bg-red-600 hover:bg-red-700 transition shadow-sm flex items-center justify-center gap-1.5"
          >
            {confirmModal.isProcessing ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin text-xs"></i>
                <span>Processing...</span>
              </>
            ) : (
              <span>{confirmModal.confirmLabel}</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
